import { render } from "./WhySogdoItsWhyChooseComp.vue?vue&type=template&id=78cedf2c&scoped=true"
import script from "./WhySogdoItsWhyChooseComp.vue?vue&type=script&lang=js"
export * from "./WhySogdoItsWhyChooseComp.vue?vue&type=script&lang=js"

import "./WhySogdoItsWhyChooseComp.vue?vue&type=style&index=0&id=78cedf2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78cedf2c"]])

export default __exports__